// gratis-gave.js

function initGratisGave(wrapper) {
  if (!wrapper) return;

  // Undgå dobbelt-init
  if (wrapper.dataset.cmGiftInit === 'true') {
    console.log('[GAVE] Wrapper allerede initialiseret, skipper');
    return;
  }
  wrapper.dataset.cmGiftInit = 'true';

  console.log('[GAVE] Initialiserer gave-wrapper', wrapper);

  // Find produkt-form
  let form = wrapper.closest('form');
  if (!form) {
    form = document.querySelector('product-form form, form[action^="/cart/add"]');
    if (!form) {
      console.warn('[GAVE] Ingen formular fundet for gave-wrapper');
      return;
    } else {
      console.log('[GAVE] Fandt formular via global form-selector:', form);
    }
  } else {
    console.log('[GAVE] Fandt formular via closest("form"):', form);
  }

  // Variant-ID'er til gaver (til check i /cart.js)
  const giftVariantIds = [
    51854111310165, // ØL 1
    51854116913493  // ØL 2
  ];

  const infoEl = wrapper.querySelector('[data-cm-gift-info]');
  const radios = wrapper.querySelectorAll('input[name="cm_gift_choice"]');

  // Tjek om gave allerede er i kurv (max 1 pr. ordre)
  async function checkGiftInCart() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return;

      const cart = await res.json();
      const hasGift = cart.items.some(item =>
        giftVariantIds.includes(Number(item.variant_id))
      );

      if (hasGift) {
        wrapper.setAttribute('data-cm-gift-already-selected', 'true');

        if (infoEl) {
          infoEl.textContent = 'Du har allerede valgt en gratis gave til denne ordre.';
        }

        radios.forEach(radio => {
          radio.disabled = true;
          radio.checked = false;
        });
      }
    } catch (err) {
      console.error('[GAVE] Fejl ved check af gave:', err);
    }
  }

  checkGiftInCart();

  // Submit-handler: vi lægger KUN gaven i kurven, og lader derefter temaet køre normalt
  form.addEventListener(
    'submit',
    async function (e) {
      console.log('[GAVE] Fangede submit-event');

      const giftAlreadySelected =
        wrapper.getAttribute('data-cm-gift-already-selected') === 'true';
      const checkedGift = wrapper.querySelector(
        'input[name="cm_gift_choice"]:checked'
      );

      console.log('[GAVE] giftAlreadySelected:', giftAlreadySelected);
      console.log('[GAVE] checkedGift:', checkedGift);

      // Hvis gaven allerede er i kurven → lad bare temaet håndtere ATC helt normalt
      if (giftAlreadySelected) {
        console.log('[GAVE] Gave allerede i kurven – lader temaet håndtere submit');
        return;
      }

      // Ingen gave valgt → blokér submit og kræv valg
      if (!checkedGift) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
        alert('Vælg venligst din gratis gave');
        console.warn('[GAVE] Ingen gave valgt — submit stoppet');
        return;
      }

      // Første gang med gave → vi tager over for DENNE submit
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }

      const giftVariantId = Number(checkedGift.value);
      console.log('[GAVE] Tilføjer kun gavevariant til kurv først:', giftVariantId);

      const payload = {
        items: [
          {
            id: giftVariantId,
            quantity: 1,
            properties: { 'Gratis gave til': 'Øl elskerens gave' }
          }
        ]
      };

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(payload)
        });

        const body = await res.text();
        console.log('[GAVE] /cart/add.js (gave) status:', res.status);
        console.log('[GAVE] Shopify respons body (gave):', body);

        if (!res.ok) {
          console.error('[GAVE] Shopify fejl ved gave-add:', body);
          return;
        }

        // Markér i UI at gave er valgt
        wrapper.setAttribute('data-cm-gift-already-selected', 'true');
        if (infoEl) {
          infoEl.textContent = 'Du har valgt din gratis gave til denne ordre.';
        }
        radios.forEach(radio => {
          radio.disabled = true;
          if (Number(radio.value) === giftVariantId) {
            radio.checked = true;
          } else {
            radio.checked = false;
          }
        });

        // Nu skal hovedproduktet lægges i kurven – det lader vi temaets egen
        // product-form logik gøre, så cart drawer opdateres korrekt.
        console.log('[GAVE] Gave tilføjet – sender nyt submit så temaet kan tilføje hovedproduktet');
        setTimeout(() => {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(); // triggerer nyt submit-event
          } else {
            form.submit(); // fallback
          }
        }, 0);
      } catch (err) {
        console.error('[GAVE] AJAX exception ved gave-add:', err);
      }
    },
    { capture: true }
  );
}

// Init ved førsteload
document.addEventListener('DOMContentLoaded', function () {
  const wrappers = document.querySelectorAll('[data-cm-gift-wrapper]');
  if (!wrappers.length) {
    console.log('[GAVE] Ingen wrappers fundet ved DOMContentLoaded');
  }
  wrappers.forEach(initGratisGave);
});

// Init igen hvis Shopify loader sektioner dynamisk (fx theme editor / AJAX)
document.addEventListener('shopify:section:load', function (event) {
  const wrappers = event.target.querySelectorAll
    ? event.target.querySelectorAll('[data-cm-gift-wrapper]')
    : [];
  wrappers.forEach(initGratisGave);
});
